module.exports = __webpack_public_path__ + "img/04a_Shop_1a.21519944.jpeg";